import dayjs from 'dayjs';
import 'dayjs/locale/da';

/**
 * Formats a date into Danish date format (e.g., 01. jan. 2024).
 *
 * If the input is null, undefined, or invalid,
 * a dash ('-') is returned instead.
 *
 * @param date - The date value to format (can be string, Date, null, or undefined).
 * @returns A formatted date string or a dash ('-') if invalid.
 */

export const formatDate = (date: string | Date | null | undefined): string => {
  if (!date) return '-';

  const parsedDate = dayjs(date);

  if (!parsedDate.isValid()) return '-';

  const formatted = parsedDate.locale('da').format('DD. MMM. YYYY');

  return formatted.replace('..', '.');
};
